import { render } from "./MakeUpTemplateDetail.vue?vue&type=template&id=465130f5&scoped=true"
import script from "./MakeUpTemplateDetail.vue?vue&type=script&lang=js"
export * from "./MakeUpTemplateDetail.vue?vue&type=script&lang=js"

import "./MakeUpTemplateDetail.vue?vue&type=style&index=0&id=465130f5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465130f5"],['__file',"src/views/h5/common/stock/makeUp/MakeUpTemplateDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "465130f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('465130f5', __exports__)) {
    api.reload('465130f5', __exports__)
  }
  
  module.hot.accept("./MakeUpTemplateDetail.vue?vue&type=template&id=465130f5&scoped=true", () => {
    api.rerender('465130f5', render)
  })

}


export default __exports__